<template>
	<div>
		<router-link :to="{ path: 'expert'}" replace
			v-if="roles.isExpert() || roles.isAdministrator() || roles.isDepartmentEmployee()">
			<v-btn>Opinie eksperckie</v-btn>
		</router-link>
		<router-link :to="{ path: 'formal'}" replace
			v-if="roles.isAdministrator() || roles.isLocalAdministrator() || roles.isDepartmentEmployee() || roles.isExpert()">
			<v-btn>Opinie formalne</v-btn>
		</router-link>
		<router-link :to="{ path: 'substantive'}" replace
			v-if="roles.isAdministrator() || roles.isLocalAdministrator() || roles.isDepartmentEmployee() || roles.isExpert()">
			<v-btn>Opinie merytoryczne</v-btn>
		</router-link>
		<router-link :to="{ path: 'final'}" replace
			v-if="roles.isAdministrator() || roles.isLocalAdministrator() || roles.isDepartmentEmployee() || roles.isExpert()">
			<v-btn>Opinie końcowe</v-btn>
		</router-link>
		<router-view>
		</router-view>
	</div>
</template>

<script>
	export default {
		name: "EvaluationPanelVue",
	};
</script>

<style scoped>
	a {
		color: white;
	}
</style>
